import { generateGroupedBarSeries } from 'utils/d3fc/chartSeries';
import { ExpectedVsActualData } from './ExpectedVsActualChart';

export const expectedVsActualSeries = (
    seriesLength: number,
    chartWidth: number
) =>
    generateGroupedBarSeries(
        seriesLength,
        chartWidth,
        ['volume-expected', 'volume-actual'],
        (d: ExpectedVsActualData) => d.barWidthPercent
    );
